import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ColorService {
  deriveNextColor(hex: string, index: number, fallback: string): string {
    const hsl = this.hexToHsl(hex);
    if (!hsl) return fallback;

    const [h, s, l] = hsl;
    const nextH = (h + 24 + (index % 3) * 8) % 360;
    const nextL = Math.min(Math.max(l + (index % 2 === 0 ? 6 : -6), 28), 72);

    return this.hslToHex(nextH, s, nextL);
  }

  private hexToHsl(hex: string): [number, number, number] | null {
    const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!m) return null;

    const [r, g, b] = [m[1], m[2], m[3]].map(x => parseInt(x, 16) / 255);
    const max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
    const l = (max + min) / 2;
    const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));

    let h = 0;
    if (d !== 0) {
      h = max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    }

    return [((h * 60) + 360) % 360, s * 100, l * 100];
  }

  private hslToHex(h: number, s: number, l: number): string {
    const hn = h / 360, sn = s / 100, ln = l / 100;

    if (sn === 0) {
      const v = Math.round(ln * 255).toString(16).padStart(2, '0');
      return `#${v}${v}${v}`;
    }

    const q = ln < 0.5 ? ln * (1 + sn) : ln + sn - ln * sn;
    const p = 2 * ln - q;
    const channel = (t: number): number => {
      t = ((t % 1) + 1) % 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const hex = (x: number) => Math.round(channel(x) * 255).toString(16).padStart(2, '0');
    return `#${hex(hn + 1 / 3)}${hex(hn)}${hex(hn - 1 / 3)}`;
  }
}
